// Collection description in two lines with "Meer weergeven", as Represent's
// "read more" (LICHT-BESLUITEN L14). The full text stays in the page for search
// engines; only the view is clamped, and only when the button hides a real part
// of the text: at least MIN_HIDDEN_WORDS words. Thomas 09-10: "het is vaak maar
// 1 of 2 woordjes die erachter zitten. Dat wil ik niet." A shorter rest shows in full.
(() => {
  const MIN_HIDDEN_WORDS = 10;
  const text = document.querySelector('.collection-banner .rte');
  if (!text) return;
  text.classList.add('is-clamped');
  if (hiddenWords(text) < MIN_HIDDEN_WORDS) {
    text.classList.remove('is-clamped');
    return;
  }
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'jc-collection-more';
  button.textContent = document.querySelector('[data-more-label]')?.dataset.moreLabel || 'Meer';
  button.setAttribute('aria-expanded', 'false');
  button.addEventListener('click', () => {
    text.classList.remove('is-clamped');
    button.remove();
  });
  text.after(button);

  /** Words of the clamped box that start below its bottom edge. */
  function hiddenWords(box) {
    const bottom = box.getBoundingClientRect().bottom;
    const walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    let count = 0;
    for (let node = walker.nextNode(); node; node = walker.nextNode()) {
      for (const word of node.data.matchAll(/\S+/g)) {
        range.setStart(node, word.index);
        range.setEnd(node, word.index + word[0].length);
        if (range.getBoundingClientRect().top >= bottom - 1) count += 1;
      }
    }
    return count;
  }
})();

// Model switch (L14): the cards show the sweater alone or on a model first;
// hover shows the other. Remembered per visitor in this browser only.
(() => {
  const button = document.querySelector('[data-model-switch]');
  if (!button) return;
  const root = document.documentElement;
  const apply = (on) => {
    root.classList.toggle('jc-show-model', on);
    button.setAttribute('aria-pressed', String(on));
  };
  let saved = false;
  try {
    saved = window.localStorage.getItem('jc-show-model') === '1';
  } catch (error) {
    saved = false;
  }
  apply(saved);
  button.addEventListener('click', () => {
    const on = !root.classList.contains('jc-show-model');
    apply(on);
    try {
      window.localStorage.setItem('jc-show-model', on ? '1' : '0');
    } catch (error) {
      // Private mode: the switch still works for this page.
    }
  });
})();
